<template>
  <!-- REMOVE POST-PAYPAL -->
  <div v-if="subscription != null && subscription.provider === 'PAYPAL'">
    <b-card no-body header-class="hidden-card-header">
      <b-card class="product-card mb-n1" style="border: solid 3px red" v-if="subscription != null && subscription.provider === 'PAYPAL'">
        <div style="color: red;"><b>Account Alert</b></div>
        <span class="mt-2" style="display: inline-block;">We have recently moved to a new system with a new payment provider which will provide users with access to new service Plans.</span>
        <br />
        Migrating your account will require a new subscription (cost adjusted for existing credit).
        <br />
        You will not lose any of your existing access time.
        <br />
        It is necessary to re-subscribe to a new Plan after you unsubscribe.
        <br />
        Your access will expire if you do not re-subscribe.
        <br />
        <b-button @click="unsubscribePaypalAndNav" class="my-2 mr-2">Click here</b-button>  to unsubscribe and be redirected to the Subscribe/Buy page.
        <br />
        More info on changes available at <a href="https://www.soldiernet.co.uk/updates/" target="_blank">https://www.soldiernet.co.uk/updates/</a>
      </b-card>
    </b-card>
  </div>
  <!-- END OF SECTION TO REMOVE -->
  <div v-else-if="subscription != null && account != null && activeproduct != null || (subscription != null && activeproduct == null)" role="tablist">
    <b-card no-body class="mb-1 adjust-plan-card">
      <b-card-header header-tag="header" class="p-2">
        <b class="ml-2">Adjust your plan</b>
      </b-card-header>
      <b-card-body>
        <div>
          <CContainer>
            <b-card-group class="m-auto" deck>

              <adjust-product-card
                v-for="product in products"
                :key="product.productid"
                :ref="'svc' + product.productid"
                class="adjust-product-card"
                :service="product"
                :price="prices.find((p) => p.productid === product.productid).txnPrice"
                :monthlyPrice="prices.find((p) => p.productid === product.productid).monthlyPrice"
                :productMonthPrice="prices.find((p) => p.productid === product.productid).productMonthPrice"
                :isActive="subscription && subscription.product.productid === product.productid"
                :activeuntil="new Date(prices.find((p) => p.productid === product.productid).toDate)"
                :canUpgrade="subscription.product.productid != undefined && subscription.product.productid < product.productid"
                :canDowngrade="subscription.product.productid != undefined && subscription.product.productid > product.productid"
                :selectedProduct="selectedProduct"
                @productSelect="clicked"
                :minimumPrice="minimumUpgradePrice"
                :disabled="prices.find((p) => p.productid === product.productid).disabled"
                :temporary="prices.find((p) => p.productid === product.productid).temporary"
              >
                <template #action>
                  <br />
                  <b-button
                    class="mx-4 mb-4"
                    :disabled="prices == undefined || (selectedProduct != null && selectedProduct.productid === product.productid && subscription.product.productid !== product.productid)"
                    :variant="subscription.product.productid === product.productid ? 'danger' : 'secondary'"
                    href="#"
                    @click="clicked(product.productid, prices.find((p) => p.productid === product.productid).disabled)"
                    >{{productButtonContent(product.productid)}}</b-button
                  >
                </template>
              </adjust-product-card>

            </b-card-group>
            <br />
            <CRow>
              <span v-if=" selectedProduct != null && !prices.find((p) => p.productid === selectedProduct.productid).temporary">
                <span style="color: red;">A subscription will continue to take payment</span>
                <span v-if="planPrice != null" style="color: red;">&nbsp;of £{{ planPrice.toFixed(2) >= 0 ? planPrice.toFixed(2) : 0.00 }}</span>
                <span style="white-space:nowrap; color: red;">&nbsp;EVERY month until you unsubscribe.</span>
              </span>
              <span v-else-if="selectedProduct != null">
                <span style="color: red;">A subscription will continue to take payment
                  <span v-if="planPrice != null" style="color: red;">
                    of £{{ planPrice.toFixed(2) >= 0 ? planPrice.toFixed(2): 0.00 }}
                  </span>
                  until the promotion expires on {{$options.filters.dateFormat(new Date(prices.find((p) => p.productid === selectedProduct.productid).tempEndDate), "dddd DD MMM YYYY")}}, then it will return to £{{prices.find((p) => p.productid === selectedProduct.productid).productMonthPrice.toFixed(2)}} every month until you unsubscribe.
                </span>
              </span>
            </CRow>
            <b-modal size="md" v-model="cancelSubscriptionModal"
                ok-only hide-backdrop no-close-on-esc no-close-on-backdrop hide-header-close centered content-class="modal-radius" header-class="modal-header">
              <template #modal-header>Cancel Subscription?</template>
              <template #default>
                Are you sure you want to unsubscribe?<br/>Once you apply these changes <strong>your subscription on this account will no longer renew.</strong>.
              </template>
              <template #modal-footer>
                <CButton class="btn-warning back-btn" @click="cancelSubscriptionModal = false">Do not cancel</CButton>
                <CButton class="btn-ghost-danger btn-outline-danger" @click="cancelSubscription()">Cancel Subscription</CButton>
              </template>
            </b-modal>
          </CContainer>
        </div>
      </b-card-body>
    </b-card>

    <b-card no-body class="adjust-plan-card mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button :disabled="selectedProduct == null || account == null || wpdetails.nextPaymentDate == null || wpdetails.amount == null || host == null" type="submit" block v-b-toggle.accordion-3 variant="info" @click="() => {getMD5(wpdetails.amount); adjustSubscriptionModal = true;}">Confirm</b-button>
      </b-card-header>
    </b-card>
    
    <b-modal size="md" v-model="adjustSubscriptionModal"
      ok-only hide-backdrop no-close-on-esc no-close-on-backdrop hide-header-close centered content-class="modal-radius" header-class="modal-header">
      <template #modal-header><b>Adjust Subscription Details</b></template>
      <template #default>
        <div class="ml-3">
          <h6 v-if="selectedProduct.productid > subscription.product.productid">Congratulations!</h6>
          <span>You are {{selectedProduct.productid > subscription.product.productid ? 'upgrading' : ' moving' }} to the {{ products.find((prod) => prod.productid === selectedProduct.productid).name }} product.</span>
          <br />
          <br />
          <span v-if="selectedProduct.productid > subscription.product.productid">Your payment of £{{ prices.find((p) => p.productid === selectedProduct.productid).txnPrice.toFixed(2) }} covers the period {{ $options.filters.dateFormat(new Date(), 'MMM DD YYYY') }} - {{ $options.filters.dateFormat(new Date(wpdetails.nextPaymentDate), 'MMM DD YYYY') }}.<br /></span>
          <div v-if="selectedProduct.productid < subscription.product.productid" class="ml-4">
            <strong class="ml-n4">This will result in the following -</strong>
            <span v-if="selectedProduct.productid < subscription.product.productid" class="mt-4">
              <br />Bandwidth will reduce from
              <span><i>'{{ subscription.product.upDescription }}'</i> to <i>'{{ selectedProduct.upDescription }}'</i></span>
            </span>
            <span v-if="selectedProduct.productid < subscription.product.productid">
              <br />Devices will reduce from
              <span>{{ subscription.product.devices }} to {{ selectedProduct.devices }} devices</span>
            </span>
          </div>
          <br />
          <span v-if="!prices.find((p) => p.productid === selectedProduct.productid).temporary">Your {{ products.find((prod) => prod.productid === selectedProduct.productid).name }} subscription will then renew at £{{ prices.find((p) => p.productid === selectedProduct.productid).monthlyPrice.toFixed(2) }} per month.</span>
          <span v-else>Your {{ products.find((prod) => prod.productid === selectedProduct.productid).name }} subscription will then renew at £{{ prices.find((p) => p.productid === selectedProduct.productid).monthlyPrice.toFixed(2) }} per month until {{ $options.filters.dateFormat(new Date(special.availto), 'dddd D MMM YYYY') }}, then revert to full monthly cost of £{{prices.find((p) => p.productid === selectedProduct.productid).productMonthPrice.toFixed(2)}}.</span>
        </div>
        <hr />
        <span class="ml-3"><strong>Total to Pay</strong> - £{{ prices.find((p) => p.productid === selectedProduct.productid).txnPrice.toFixed(2) }}</span>
      </template>
      <template #modal-footer>
        <CButton class="btn-outline-danger back-btn" @click="adjustSubscriptionModal = false">Cancel</CButton>
        <form v-if="(selectedProduct.productid > subscription.product.productid && prices.find((p) => p.productid === selectedProduct.productid).txnPrice > 0 || prices.find((p) => p.productid === selectedProduct.productid).txnPrice > 0)" 
          :action="worldpay.baseurl + 'purchase'" method=POST ref='adjustForm' @submit.prevent="handleFormSubmit('adjustForm')">
          <!-- Specifies the URL for our test environment -->
          <input type="hidden" name="testMode" :value="worldpay.testMode"> 
          <!-- 100 instructs our test system - could use node environment variable to diff between production and development -->
          <input type="hidden" name="instId" :value="worldpay.instRef"> 
          <!-- A mandatory parameter -->
          <input type="hidden" name="cartId" value="SoldierNET Broadband"> 
          <!-- A mandatory parameter - reference for the item purchased -->
          <!-- SNet fields - Common Mandatory -->
          
          <input type="hidden" name="M_username" :value="account.username"> 
          <input type="hidden" name="M_productid" :value="wpdetails.productid" > 
          <input type="hidden" name="M_period" value="MONTH" >  
          <!-- Additional action type - SUBSCRIBEPAY, SUBSCRIBEONLY or FLEXICREDITS -->
          <input type="hidden" name="M_ACTION" :value="wpdetails.amount > 0 || (wpdetails.amount == 0 && special == null) ? 'SUBSCRIBEPAY' : 'SUBSCRIBEONLY'">
          <!-- NEED SITE WIRED IN -->
          <input type="hidden" name="M_siteid" :value="site.siteid" >
          <!-- NEED CLIENT PORTAL ADDRESS -->
          <input v-if="onnet && status != null && status.session != null" type="hidden" name="M_cpAddress" :value="status.session.lease.ip">
          <!-- Initial payment amount -->
          <input type="hidden" name="amount" :value="wpdetails.amount >= 0 ? wpdetails.amount : 0"> 
          <!-- A mandatory parameter -->
          <input type="hidden" name="currency" value="GBP"> 
          <!-- A mandatory parameter. ISO currency code -->
          <input type="hidden" name="hideCurrency" > 
          <!-- SNet fields - If initial payment -->
          <input type="hidden" name="M_until" :value="wpdetails.nextPaymentDate" > 
          <!-- futurepay -->
          <input type="hidden" name="futurePayType" value="limited"> 
          <!-- limited or regular (may be unlimited) -->
          <input type="hidden" name="option" value="0">
          <!-- redirect URL -->
          <input type="hidden" name="M_redirect" :value="host">   
          <!-- MD5 signed and timeout -->
          <input type="hidden" name="signature" :value="signature" />
          <input type='hidden' name='signatureFields' value='instId:amount:currency' />
          <input type="hidden" name=authValidTo :value="authValidUntil(15)">  
          <!-- SNet fields - If futurepay -->
          <input v-if="special != null" type="hidden" name="M_specialid" :value="special.id" > 
          <CButton type="submit" class="btn-info"
            :disabled="account == null || wpdetails.nextPaymentDate == null || wpdetails.amount == null || host == null">Confirm and Pay</CButton>
        </form>
        <CButton v-else type="button" class="btn-info" :disabled="account == null || wpdetails.nextPaymentDate == null || wpdetails.amount == null || host == null" @click="updateSubscriptionWithNoPayment()">Confirm and Pay</CButton>
      </template>
    </b-modal>

  </div>
      
  
  <!-- flexiadjust -->

  <div v-else-if="subscription == null && account != null && activeproduct != null && account.flexiplan != null" role="tablist">
    
    <b-card no-body class="mb-1 adjust-plan-card">
      <b-card-header header-tag="header" class="p-2">
        <b class="ml-2">Adjust your FlexiPlan</b>
      </b-card-header>
      <b-card-body>
        <div>
          <CContainer>
            <b-card-group class="m-auto" deck>
              <adjust-flexi-card
                v-for="product in products"
                :key="product.productid"
                class="adjust-product-card"
                :ref="'flex' + product.productid"
                :service="product"
                :isActive="account.flexiplan.product && account.flexiplan.product.productid === product.productid"
                :activeuntil="new Date(lastActiveuntil)"
                :canUpgrade="account.flexiplan.product.productid < product.productid && account.flexiplan.product.productid != undefined"
                :canDowngrade="account.flexiplan.product.productid > product.productid && account.flexiplan.product.productid != undefined"
                :selectedProduct="selectedFlexiProduct"
                :entitlements="entitlements"
                @productSelect="flexClicked(product.productid)"
              >
                <template #action>
                  <br />
                  <b-button
                    class="mx-4 mb-4"
                    :disabled="account.flexiplan.product.productid === product.productid || (selectedFlexiProduct != null && selectedFlexiProduct.productid === product.productid)"
                    :variant="account.flexiplan.product.productid === product.productid ? 'success' : 'secondary'"
                    href="#"
                    >{{flexiProductButtonContent(product.productid)}}</b-button
                  >
                </template>
              </adjust-flexi-card>
            </b-card-group>
          </CContainer>
        </div>
      </b-card-body>
    </b-card>
    <b-card no-body class="adjust-plan-card mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button :disabled="selectedFlexiProduct == null || account == null || flexidetails.credits == null || flexidetails.productid == null || host == null || selectedFlexiProduct.productid == account.flexiplan.product.productid" type="button" block v-b-toggle.accordion-3 variant="info" @click="adjustFlexiModal = true">Confirm</b-button>
      </b-card-header>
    </b-card>


    <b-modal size="md" v-model="adjustFlexiModal"
      ok-only hide-backdrop no-close-on-esc no-close-on-backdrop hide-header-close centered content-class="modal-radius" header-class="modal-header">
      <template #modal-header><b class="mx-3">Adjust FlexiPlan Details</b></template>
      <template #default>
        <div class="mx-3">
          <h6><strong>Payment Breakdown</strong></h6>
          <span>Adjustment Cost : {{upgradeCreditCost(products.find((p) => p.productid === selectedProduct.productid), activeproduct, entitlements).toFixed(0)}} FlexiCredit{{ upgradeCreditCost(products.find((p) => p.productid === selectedProduct.productid), activeproduct, entitlements).toFixed(2) === 1 ? '' : 's' }}</span>
          <br />
          <span>Daily Cost : {{products.find((p) => p.productid === selectedProduct.productid).credits.toFixed(0)}} FlexiCredit{{ products.find((p) => p.productid === selectedProduct.productid).credits.toFixed(0) === 1 ? '' : 's' }}</span>
          <br />
          <span>Boost Until : {{ new Date(lastActiveuntil).toDateString() }}</span>
          <span v-if="account.flexiplan.credits < flexidetails.credits">
            <br /><br />
            <strong>You do not have enough FlexiCredits</strong>.
            <br />
            Buy more via <strong><router-link to="/buysubscribe">Subscribe/Buy</router-link></strong>.
          </span>
        </div>
      </template>
      <template #modal-footer>
        <CButton class="btn-outline-danger back-btn" @click="adjustFlexiModal = false">Cancel</CButton>
        <CButton type="button" class="btn-info" :disabled="account == null || flexidetails.credits == null || flexidetails.productid == null || host == null || account.flexiplan.credits < flexidetails.credits" @click="updateFlexi()">Adjust Now</CButton>
      </template>
    </b-modal>


  </div>

  <div v-else>To access this page you must purchase a subscription via <router-link to="/buysubscribe">Subscribe/Buy</router-link> or have an active FlexiPlan product.
    <span v-if="account != null && account.flexiplan != null && account.flexiplan.credits >= account.flexiplan.product.credits"><br />Click <b-button class="p-0 mt-n1" variant="link" @click="startDayAccess">here</b-button> to gain access <strong>(action has a cost of {{ account.flexiplan.product.credits }}{{ account.flexiplan.product.credits === 1 ? ' FlexiCredit' : ' FlexiCredits' }})</strong>.<br /></span>
    <div v-else-if="account != null && account.flexiplan != null && account.flexiplan.credits < account.flexiplan.product.credits && account.flexiplan.credits != 0">
    </div>
  </div>
</template>

<script>
import SpecialOffer from "../../components/specials/SpecialOffer.vue";
import AdjustProductCard from "../../components/product/AdjustProductCard.vue";
import AdjustFlexiCard from '@/components/product/AdjustFlexiCard';
import { productFromID } from '../../helpers/pricing.plugin';
import { mapState, mapGetters, mapActions } from "vuex";
import { startpaywall, checkMyStatus } from 'src/cpd';

export default {
  name: "AdjustPlan",
  components: {
    AdjustProductCard,
    AdjustFlexiCard,
    SpecialOffer,
  },
  data: () => ({
    cancelSubscriptionModal: false,
    wpdetails: {
      amount: undefined,
      nextPaymentDate: undefined,
      productid: undefined
    },
    flexidetails: {
      credits: undefined,
      productid: undefined
    },
    adjustSubscriptionModal: false,
    adjustFlexiModal: false,
    adjustType: 0,
    applynow: true,
    signature: ""
  }),
  computed: {
    ...mapGetters({
      products: "pricing/getProducts",
      prices: "pricing/getPrices",
      flexiPrices: "pricing/getFlexiPrices",
      selectedProduct: "pricing/getChosenAdjustedProduct",
      selectedPeriod: "pricing/getChosenPeriod",
      special: "pricing/getSpecial",
      subscription: "plan/getSubscription",
      activeproduct: "plan/getActiveProduct",
      activeuntil: "plan/getActiveUntil",
      lastActiveuntil: "plan/getLastActiveUntil",
      entitlements: "plan/getBaseEntitlements",
      minimumUpgradePrice: "pricing/getMinimumUpgradePrice",
      site: "account/site",
      worldpay: "pricing/getWorldpay",
      account: "account/account"
    }),

    ...mapState("captive", {      
      onnet: state => state.onnet,
      status: state => state.status
    }),
    
    mac() {
      return this.status?.session?.lease?.ethernet || null;
    },
    ipAddress() {
      return this.status?.session?.lease?.ip || null;
    },

    planPrice: function(){ 
      return this.selectedProduct == null ? null : this.singlePlanPrice(this.prices, this.selectedProduct.productid)  
    },

    host() {
      return window.location.host;
    },

    selectedFlexiProduct() {
      return this.flexidetails.productid ? productFromID(this.flexidetails.productid) : null
    }

    // dayCost() {
    //   let currentDate = new Date();
    //   let timeDiff = new Date(this.activeuntil) - currentDate;

    //   let days =  Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    //   let dayCost = ((this.prices.find((p) => p.productid === this.selectedProduct.productid).monthlyPrice - this.prices.find((p) => p.productid === this.activeproduct.productid).monthlyPrice) / 30)

    //   return days * dayCost;
    // }
    
  },
  methods: {
    handleFormSubmit(ref) {
      // handles submission of Worldpay payment details
      try {
        let paywallResponse;
        if ( this.$store.getters['captive/isOnNet'] ) {
          paywallResponse = startpaywall(this.ipAddress, this.mac);
        } else {
          paywallResponse = true;
        }
        // console.log(JSON.stringify(paywallResponse))
        // console.log(JSON.stringify(paywallResponse.data))
        if (paywallResponse) {
          // If response is successful, submit the specified form
          this.$refs[ref].submit();
        } else {
          // Handle errors or unsuccessful conditions
          console.error("Failed to initialize paywall");
        }
      } catch (error) {
        console.error("Error in submitting paywall request:", error);
      }
    },
    logItem(item) {
      this.$log.onDebug(JSON.stringify(item))
    },
    
    getMD5(amount) {
      // Fetches MD5 value required for submission to Worldpay
      this.$portalapi.get("worldpay/prepare", { params: { amount: amount, currency: "GBP" } }).then((response) => {
        this.signature = response.data;
        this.$log.onDebug("Prepared data for worldpay transaction has been recieved - " + JSON.stringify(response.data));
      },
      (error) => {
        this.$log.onError("Failed to prepare for worldpay transaction due to error - " + JSON.stringify(error))
      })
    },
    authValidUntil(timeoutMins) {
      // Get the current time
      var now = new Date();

      // Add specified minutes to the current time
      now.setMinutes(now.getMinutes() + timeoutMins);

      // Convert the time to a Unix timestamp in seconds
      return Math.floor(now.getTime());
    },

    unsubscribePaypalAndNav() {
      // Removes legacy Paypal subscription for current user and takes them to the subscription page
      this.$log.onError('starting paypal unsubscribe')
        this.$portalapi.get('/legacy/unsubscribe', { params: {userName: this.account.username} } ).then( (response) => {
          this.$log.onError(response);
          this.$router.push('/buysubscribe');
        })
    },
    
    upgradeCreditCost(service, activeproduct, entitlements) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);  // normalize to the start of the day
        
        let total = 0;

        for (let e of entitlements) {
            // get total days between now and enddate
            let differenceInDays = Math.floor((new Date(e.dateto) - today) / (1000 * 60 * 60 * 24));
            if (entitlements.indexOf(e) === entitlements.length - 1) {
              differenceInDays += 1;
            }
            if (!isNaN(differenceInDays)) {
                total += (differenceInDays * (service.credits - activeproduct.credits));
            }
        }

        return total > 0 ? total : 0;
    },

    updateFlexi() {
      this.$log.onDebug('adjusting flexi')
      // Upgrade or downgrade current users flexiplan tier
      this.$portalapi.get('flexiplan/adjust', { params: { productid: this.flexidetails.productid, applynow: this.applynow, credits: this.flexidetails.credits} } ).then((response) => {
        this.$log.onDebug(JSON.stringify(response))
        this.$router.push("/account/info")
      })
    },

    startDayAccess() {
      let credits = this.account.flexiplan.credits >= this.account.flexiplan.product.credits ? this.account.flexiplan.product.credits : this.account.flexiplan.credits
      let productid = this.products.find((product) => product?.credits === credits).productid
      this.$portalapi.get('flexiplan/day', { params: { productid: productid, credits: credits } } )
      .then((response) => {
        this.$log.onError(response.data)
        this.$router.push("/account/info")
      }).catch((error) => {
        this.$log.onError(error.data)
        alert('Failed to start FlexiPlan access. Please buy credits if you have less than the required amount or contact SoldierNET.')
      })
    },

    updateSubscriptionWithNoPayment() {
      this.$log.onDebug('special value is ' + this.special)
      // Send request to adjust user subscription with no Worldpay payment required (generally a downgrade on a paid subscription, upgrade results in entitlement product increase as nothing to pay)
      this.$portalapi.get('adjustsubscribe', { params: { specialid: this.special?.id, productid: this.wpdetails.productid } }).then((response) => {
        this.$log.onDebug(JSON.stringify(response))
        // Get updated subscription details on success
        this.$store.dispatch("plan/initialiseSubscription")
        // Navigate to the Account Info page to show updated content
        this.$router.push("/account/info")
      }, (error) => {
        alert('Subscription adjustment failed.\nError object returned as below:\n' + JSON.stringify(error))
        this.$log.onDebug(error.data)
      })
    },

    ...mapActions('pricing', ['setChosenAdjustedProduct', 'setChosenPeriod', 'setSpecial']),

    logItem(item) {
      this.$log.onDebug(JSON.stringify(item))
    },
    
    clicked(productid, disabled) {
      // Runs when a subscription adjust-product-card is clicked to update relevant payment/product details
      // Argument values are emitted from the adjust-product-card as part of the productSelect emit event

      // Ensure the card is not in a disabled state
      if (!disabled) {
        // Defensive conditional to prevent
        this.subscription.product.productid === productid ? this.cancelSubscriptionModal = true : this.setChosenAdjustedProduct(productid);
        if (this.subscription.product.productid != productid) {
          this.wpdetails.productid = productid
          this.wpdetails.amount = this.prices.find((p) => p.productid === this.selectedProduct.productid).txnPrice.toFixed(2)
          this.wpdetails.nextPaymentDate = this.$options.filters.dateFormat(new Date(this.prices.find((p) => p.productid === productid).toDate), 'YYYY-MM-DD HH:mm:ss')
          this.$log.onDebug(JSON.stringify(this.wpdetails) + ' and pid is ' + productid)
        }
      }
    },

    flexClicked(productid) {
      // Runs when a flexiplan adjust-flexi-card is clicked to update relevant payment/product details
      // Argument values are emitted from the adjust-flexi-card as part of the productSelect emit event

      if (this.account.flexiplan.product.productid != productid) {
        if(this.productid != this.account.flexiplan.product.productid) {
          this.setChosenAdjustedProduct(productid);
        }
        this.flexidetails.productid = productid
        let ref = `flex${productid}`;
        this.flexidetails.credits = this.upgradeCreditCost(this.products.find((p) => p.productid === productid), this.activeproduct, this.entitlements)
        this.$log.onDebug('flexidetails.credits = ' + this.flexidetails.credits)
      }
    },

    singlePlanPrice(prices, plan){
      if ( prices != undefined) {
        switch (plan) {
          case 1:
            return prices.find((p) => p.productid === 1).monthlyPrice
          case 2:
          return prices.find((p) => p.productid === 2).monthlyPrice
          case 3:
          return prices.find((p) => p.productid === 3).monthlyPrice
          default:
            return null
        } 
      } else {
        return null
      }
    },   

    flexiProductButtonContent(productid) {
      return this.account.flexiplan.product.productid === productid ? 'Active' : this.selectedFlexiProduct?.productid === productid ? 'Selected' : this.account.flexiplan.product.productid > productid ? 'Downgrade' : 'Upgrade';
    },

    productButtonContent(productid) {
      return this.subscription.product.productid === productid ? 'Unsubscribe' : this.selectedProduct == null ? 'Select' : this.selectedProduct.productid === productid ? 'Selected' : this.subscription.product.productid < productid ? 'Upgrade' : 'Downgrade' // upgrade or downgrade here
    },

    cancelSubscription() {
      this.$log.onDebug('Cancel subscription method is running!')
      // This endpoint does a clean unsubscribe for all types of subscription
      // runs worldpay then paypal then snet for unsubscribe attempt
      this.$portalapi.get('unsubscribe').then((response) => {
        this.$log.onDebug(JSON.stringify(response))
        this.$store.dispatch("plan/initialiseSubscription")
        this.$router.push("/account/info")
      }, (error) => {
        alert('Subscription adjustment failed.\nError object returned as below:\n' + JSON.stringify(error))
        this.$log.onDebug(error.data)
      })
      this.$log.onDebug('Cancel subscription method has run!')
    }
  },
  mounted() {
    this.$store.dispatch("plan/initialiseSubscription")
    checkMyStatus();
    this.$log.onError('mounted test in adjust')
    this.$log.onError('prices is ' + JSON.stringify(this.prices))
    this.$store.dispatch('pricing/initialisePrices', true)
    this.$store.dispatch('account/getAccount')
    this.setChosenAdjustedProduct(this.subscription.productid)
  },
  created() {
    this.$emit('updateAccount')
  }
};
</script>

<style lang="scss" scoped>

.cut-btn {
  width: 110px;
  color: white;

  outline: #39123D  1px;
  border-radius: 20px 20px 20px 20px;
  cursor: pointer;
  opacity: 60%;

  -moz-transition: all .3s ease-in;
  -o-transition: all .3s ease-in;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  background: #39123D;
  font-weight: 500;

  &:hover {
    opacity: 100%;
    background-color: darkmagenta;
    outline: #39123D solid 3px;
  }
}


.cut-btn:checked {
  opacity: 100%;
  background-color: darkmagenta;
  box-shadow: none;
}

.selected {
  opacity: 100%;
  background-color: darkmagenta;
  box-shadow: none;
}

.central {
  margin: auto;
}

.modal-header {
  background-color: #471747;
  color: white;
}

.adjust-product-card {
  min-width: 260px;
  max-width: 260px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.adjust-plan-card {
  max-width: 950px;
}

.hidden-card-header {
  display: none;
}

</style>